export default __webpack_public_path__ + "static/media/eggplant.7be563cd.png";